import React, { Component } from "react";
import PropTypes from "prop-types";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";
import { MentionsInput, Mention } from "react-mentions";
import defaultStyle from "./defaultStyle";
import defaultMentionStyle from "./defaultMentionStyle";

export default class MentionBox extends Component {
  static propTypes = {
    usernameList: PropTypes.arrayOf(
      PropTypes.shape({
        display: PropTypes.string,
        id: PropTypes.string,
      })
    ),
    updateTaggingList: PropTypes.func,
    handleCommentTextChange: PropTypes.func,
    value: PropTypes.string,
  };

  static defaultProps = {
    usernameList: [],
    updateTaggingList: () => {},
    handleCommentTextChange: () => {},
    value: "",
  };

  constructor(props) {
    super(props);
    this.handleEditComment = this.handleEditComment.bind(this);
    this.handleMentionDisplay = this.handleMentionDisplay.bind(this);
  }

  handleEditComment = (e, newValue, newPlainTextValue, mentions) => {
    this.props.updateTaggingList(mentions);
    this.props.handleCommentTextChange(newPlainTextValue, e);
  };

  handleMentionDisplay = (id, display) => `@${display}`;

  render() {
    const { usernameList, value } = this.props;

    return (
      <I18n>
        {({ i18n }) => (
          <MentionsInput
            className="mentions-input"
            onChange={this.handleEditComment}
            style={defaultStyle}
            value={value}
            markup="@[__display__](__type__:__id__)"
            placeholder={i18n._(t("mention_box.add_comment")`Add Comment`)}
            displayTransform={this.handleMentionDisplay}
            data-cy="AddCommentBox-MentionBox"
          >
            <Mention
              type="user"
              trigger="@"
              data={usernameList}
              style={defaultMentionStyle}
              appendSpaceOnAdd={false}
            />
          </MentionsInput>
        )}
      </I18n>
    );
  }
}
